import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HomePage } from './components/HomePage'
import { StreamerInterface } from './components/StreamerInterface'
import { ViewerInterface } from './components/ViewerInterface'
import { AudioCapture } from './components/AudioCapture'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/streamer" element={<StreamerInterface />} />
          <Route path="/viewer" element={<ViewerInterface />} />
          <Route path="/test" element={<AudioCapture />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)